import { createDuck } from '@/utils/'
// import { USER_STATUS } from '@/utils/const'

import {
  fetchCart,
  fetchProducts,
  fetchRecommend,
  fetchSkeleton,
  getDailyReward,
  getHomePageInfo,
  // fetchActivityInfo,
} from '@/services/api/home'
/**
 * 获取需要去下载详细信息的商品 Id
 */
function getWaitedIds(skData) {
  const { page } = skData
  const { data } = page
  const ids = []
  data.forEach(item => {
    if (item.type === 'E1') {
      const { items } = item.data
      for (let { id } of items) {
        ids.push(id)
      }
    }
    if (item.type === 'H2') {
      const items = item.data
      for (let { id } of items) {
        ids.push(id)
      }
    }
  })
  return ids
}

function transProductUrl(item) {
  const item_base_url_dns = '//fulfillment.bczcdn.com/'
  const item_base_path = 'rc201603281546'
  const patt = /^(http|https|\/\/)/
  let mUrlImagesSmall = item['mUrlImagesSmall']
  let promotion = item['promotion']
  if (mUrlImagesSmall && !patt.test(mUrlImagesSmall)) {
    mUrlImagesSmall = item_base_url_dns + item_base_path + mUrlImagesSmall
  }
  if (promotion) {
    let discountImageSmall = promotion['itemPromotions'][0]?.discountImageSmall
    if (discountImageSmall && !patt.test(discountImageSmall)) {
      discountImageSmall = item_base_url_dns + item_base_path + discountImageSmall
    }
    promotion = {
      ...promotion,
      discountImageSmall,
    }
  }
  return {
    ...item,
    mUrlImagesSmall,
    promotion,
  }
}
export const duck = createDuck({
  name: 'homeDuck',
  initialState: {
    isLoadSkeleton: false,
    /** @type {home.Sketeton} */
    skeleton: {},
    waitedIds: [], // 等待获取商品详情的 id
    recommendIds: [], // 推荐的商品列表
    products: {}, // 存储产品详细信息
    cart: 0, // 购物车数量
    taobaoCode: '', // 点击淘宝按钮复制的口令
    dailyReard: -1,
    diff: 0,
    showDailyReard: false, //是否显示领取铜板按钮
    newUserCreditActivityVo: null, //新⽤户活动信息
  },
  actions: {
    setSkeleton(data) {
      return dispatch => {
        dispatch(
          duck.change({
            isLoadSkeleton: true,
            ...data,
          }),
        )
      }
    },

    setRecommend(data) {
      return dispatch => {
        dispatch(
          duck.change({
            recommendIds: data,
          }),
        )
      }
    },
    setDiff(val) {
      return dispatch => {
        dispatch(
          duck.change({
            diff: val,
          }),
        )
      }
    },

    setProducts(data) {
      return dispatch => {
        dispatch(
          duck.merge({
            products: {
              ...data,
            },
          }),
        )
      }
    },

    setCart(data) {
      return dispatch => {
        dispatch(
          duck.change({
            cart: data,
          }),
        )
      }
    },

    setShowDailyAward(val) {
      return dispatch => {
        dispatch(
          duck.change({
            showDailyReard: val,
          }),
        )
      }
    },
    fetchSkeletonAsync(trace) {
      return async dispatch => {
        try {
          const jsonData = await fetchSkeleton(trace)
          // @ts-ignore
          const skData = JSON.parse(jsonData)
          // @ts-ignore
          const waitedIds = getWaitedIds(skData)
          dispatch(
            duck.change({
              isLoadSkeleton: true,
              skeleton: skData,
              waitedIds,
              adv: skData.adv,
              taobaoCode: skData.common.taobaoCode,
            }),
          )
        } catch (error) {
          window.alert('3' + error.message)
        }
      }
    },

    refreshAdv(trace) {
      return async dispatch => {
        try {
          const jsonData = await fetchSkeleton(trace)
          // @ts-ignore
          const skData = JSON.parse(jsonData)
          dispatch(
            duck.change({
              adv: skData.adv,
            }),
          )
        } catch (error) {
          window.alert('3' + error.message)
        }
      }
    },

    fetchRecommendAsync() {
      return async dispatch => {
        try {
          const recData = (await fetchRecommend()) || []
          // @ts-ignore
          const recIds = recData.map(item => item.id)
          const recProducts = {}
          if (recData) {
            // @ts-ignore
            recData.forEach(item => {
              recProducts[item.id] = transProductUrl(item)
            })
          }

          dispatch(
            duck.change({
              recommendIds: recIds,
            }),
          )
          dispatch(
            duck.merge({
              products: recProducts,
            }),
          )
        } catch (error) {
          console.log(error)
          window.alert('2' + error.message)
        }
      }
    },

    fetchProductsAsync() {
      return async (dispatch, getState) => {
        const {
          homeDuck: { waitedIds },
        } = getState()
        let startIdx = 0
        while (startIdx < waitedIds.length) {
          const ids = waitedIds.slice(startIdx, startIdx + 10)
          startIdx += 10
          try {
            const productData = await fetchProducts(ids)
            const products = {}
            // @ts-ignore
            productData.forEach(item => {
              if (item) {
                products[item.id] = transProductUrl(item)
              }
            })
            dispatch(this.setProducts(products))
          } catch (error) {
            console.log(error)
          }
        }
      }
    },
    fetchCartAsync() {
      return async dispatch => {
        try {
          // @ts-ignore
          const { count } = await fetchCart()
          dispatch(duck.setCart(count))
        } catch (error) {
          window.alert('1' + error && error.message)
        }
      }
    },
    ///api/mall/proxy/homepage/get_home_page_info
    fetchHomePageInfo() {
      return async dispatch => {
        try {
          // @ts-ignore
          const { dailyCreditStatus, serverTime, newUserCreditActivityVo } = await getHomePageInfo()
          dispatch(
            duck.change({
              newUserCreditActivityVo,
              showDailyReard: !dailyCreditStatus,
              serverTime,
            }),
          )
        } catch (error) {
          console.log('error')
        }
      }
    },
    newUserEnd() {
      return async dispatch => {
        dispatch(
          duck.change({
            newUserCreditActivityVo: null,
          }),
        )
      }
    },
    changeSubsidyStatus(val) {
      return async (dispatch, getState) => {
        const {
          homeDuck: { newUserCreditActivityVo },
        } = getState()
        dispatch(
          duck.change({
            newUserCreditActivityVo: {
              ...newUserCreditActivityVo,
              subsidyStatus: val,
            },
          }),
        )
      }
    },

    fetchDailyReward() {
      return async dispatch => {
        try {
          // @ts-ignore
          const { credit } = await getDailyReward()
          dispatch(
            duck.change({
              dailyReard: credit || 0,
              showDailyReard: false,
            }),
          )
          return credit
        } catch (error) {
          console.log('error')
        }
      }
    },
  },
})
